export default __webpack_public_path__ + "static/media/circle-cropped.4aa20ead.png";